import { createAction, props } from '@ngrx/store';

export const enum GtmActionTypes {
  sendPageViewEvent = '[gtm] SEND_PAGE_VIEW_EVENT',
  sendPurchaseEvent = '[gtm] SEND_PURCHASE_EVENT',
}

export const sendPageViewEvent = createAction(
  GtmActionTypes.sendPageViewEvent,
  props<{ url: string }>(),
);

export const sendPurchaseEvent = createAction(GtmActionTypes.sendPurchaseEvent);
